import { useState } from 'react'

export const useCopyToClipboard = () => {
  const [isCopied, setIsCopied] = useState(false)

  const copyToClipboard = async (text: string) => {
    setIsCopied(true)
    await navigator.clipboard.writeText(text)

    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }

  return {
    isCopied,
    actions: { copyToClipboard }
  }
}
